// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/imgs/logo-removebg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cardTheme {
  background: white;
  width: 300px;
  height: 30vh;
  border-radius: 10px;
  margin: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.cardTheme img {
  position: absolute;
  top: 9px;
  right: 20px;
  width: 70px;
}
.cardTheme p {
  color: #282881;
  font-size: 30px;
  font-family: "Times New Roman", Times, serif;
  margin: 0;
}
.cardTheme .buttonContainer {
  position: absolute;
  display: flex;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}
.cardTheme .buttonContainer button {
  background-color: #282881;
  color: white;
  font-size: 21px;
  border: none;
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px;
}
.cardTheme .buttonContainer {
  /* Réduire l'opacité au survol du bouton */
}
.cardTheme .buttonContainer:hover button {
  opacity: 1;
}
.cardTheme {
  /* Afficher les boutons au survol */
}
.cardTheme:hover .buttonContainer {
  opacity: 1;
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/CardTheme/cardtheme.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AAEF;AAAE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAEJ;AACE;EACE,cAAA;EACA,eAAA;EACA,4CAAA;EACA,SAAA;AACJ;AAEE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,mDAAA;AAAJ;AAEI;EAEE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADN;AAnBE;EAuBE,0CAAA;AADJ;AAEI;EACE,UAAA;AAAN;AAtDA;EA0DE,mCAAA;AADF;AAEE;EACE,UAAA;EACA,mBAAA;AAAJ","sourcesContent":[".cardTheme {\n  background: white;\n  width: 300px;\n  height: 30vh;\n  border-radius: 10px;\n  margin: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center; \n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  background-image: url(../../../assets/imgs/logo-removebg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n\n  img {\n    position: absolute;\n    top: 9px;\n    right: 20px;\n    width: 70px;\n  }\n\n  p {\n    color: #282881;\n    font-size: 30px;\n    font-family: \"Times New Roman\", Times, serif;\n    margin: 0;\n  }\n  \n  .buttonContainer {\n    position: absolute;\n    display: flex;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n\n    button {\n      // opacity: 0.7;\n      background-color: #282881;\n      color: white;\n      font-size: 21px;\n      border: none;\n      padding: 10px;\n      border-radius: 50%;\n      cursor: pointer;\n      transition: opacity 0.3s ease;\n      display: flex; \n      align-items: center;\n      justify-content: center;\n      margin: 30px;\n    }\n\n    /* Réduire l'opacité au survol du bouton */\n    &:hover button {\n      opacity: 1;\n    }\n  }\n\n  /* Afficher les boutons au survol */\n  &:hover .buttonContainer {\n    opacity: 1;\n    visibility: visible;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
